const timetable: any = [
  {
    name: 'Цифровая трансформация: ключевые аспекты',
    url: 'https://cdto.ranepa.ru/program-registry/from-the-first-steps',
    cost: '65 000₽',
    streams: [
      {'from': '05.02.2024', 'to': '16.04.2024'},
      {'from': '20.02.2024', 'to': '07.05.2024'},
      {'from': '05.03.2024', 'to': '22.05.2024'},
      {'from': '19.03.2024', 'to': '04.06.2024'},
      {'from': '02.04.2024', 'to': '19.06.2024'},
      {'from': '16.04.2024', 'to': '03.07.2024'},
      {'from': '07.05.2024', 'to': '18.07.2024'},
      {'from': '21.05.2024', 'to': '30.07.2024'},
      {'from': '04.06.2024', 'to': '13.08.2024'},
      {'from': '18.06.2024', 'to': '26.08.2024'},
      {'from': '02.07.2024', 'to': '09.09.2024'},
      {'from': '16.07.2024', 'to': '23.09.2024'},
      {'from': '30.07.2024', 'to': '08.10.2024'},
      {'from': '13.08.2024', 'to': '21.10.2024'},
      {'from': '03.09.2024', 'to': '12.11.2024'},
      {'from': '17.09.2024', 'to': '26.11.2024'},
      {'from': '01.10.2024', 'to': '10.12.2024'}
    ]
  },
  {
    name: 'Целеполагание и принятие решений в практике цифрового развития организации',
    url: 'https://cdto.ranepa.ru/program-registry/decisions',
    cost: '50 000₽',
    streams: [
      {'from': '05.02.2024', 'to': '19.03.2024'},
      {'from': '20.02.2024', 'to': '03.04.2024'},
      {'from': '06.03.2024', 'to': '17.04.2024'},
      {'from': '19.03.2024', 'to': '04.05.2024'},
      {'from': '02.04.2024', 'to': '21.05.2024'},
      {'from': '17.04.2024', 'to': '05.06.2024'},
      {'from': '07.05.2024', 'to': '20.06.2024'},
      {'from': '21.05.2024', 'to': '02.07.2024'},
      {'from': '04.06.2024', 'to': '16.07.2024'},
      {'from': '18.06.2024', 'to': '29.07.2024'},
      {'from': '02.07.2024', 'to': '12.08.2024'},
      {'from': '17.07.2024', 'to': '27.08.2024'},
      {'from': '31.07.2024', 'to': '10.09.2024'},
      {'from': '14.08.2024', 'to': '24.09.2024'},
      {'from': '03.09.2024', 'to': '14.10.2024'},
      {'from': '17.09.2024', 'to': '28.10.2024'},
      {'from': '02.10.2024', 'to': '13.11.2024'},
      {'from': '08.10.2024', 'to': '19.11.2024'},
      {'from': '22.10.2024', 'to': '03.12.2024'}
    ]
  },
  {
    name: 'Основы управления данными',
    url: 'https://cdto.ranepa.ru/program-registry/data-management',
    cost: '55 000₽',
    streams: [
      {from: '05.02.2024', to: '16.04.2024'},
      {from: '20.02.2024', to: '07.05.2024'},
      {from: '05.03.2024', to: '22.05.2024'},
      {from: '19.03.2024', to: '04.06.2024'},
      {from: '02.04.2024', to: '19.06.2024'},
      {from: '16.04.2024', to: '03.07.2024'},
      {from: '07.05.2024', to: '18.07.2024'},
      {from: '21.05.2024', to: '30.07.2024'},
      {from: '04.06.2024', to: '13.08.2024'},
      {from: '18.06.2024', to: '26.08.2024'},
      {from: '02.07.2024', to: '09.09.2024'},
      {from: '16.07.2024', to: '23.09.2024'},
      {from: '30.07.2024', to: '08.10.2024'},
      {from: '13.08.2024', to: '21.10.2024'},
      {from: '03.09.2024', to: '12.11.2024'},
      {from: '17.09.2024', to: '26.11.2024'},
      {from: '01.10.2024', to: '10.12.2024'}
    ]
  },
  {
    name: 'Создание и развитие цифровых команд',
    url: 'https://cdto.ranepa.ru/program-registry/creation-team',
    cost: '55 000₽',
    streams: [
      {from: '05.02.2024', to: '16.04.2024'},
      {from: '20.02.2024', to: '07.05.2024'},
      {from: '05.03.2024', to: '22.05.2024'},
      {from: '19.03.2024', to: '04.06.2024'},
      {from: '02.04.2024', to: '19.06.2024'},
      {from: '16.04.2024', to: '03.07.2024'},
      {from: '07.05.2024', to: '18.07.2024'},
      {from: '21.05.2024', to: '30.07.2024'},
      {from: '04.06.2024', to: '13.08.2024'},
      {from: '18.06.2024', to: '26.08.2024'},
      {from: '02.07.2024', to: '09.09.2024'},
      {from: '16.07.2024', to: '23.09.2024'},
      {from: '30.07.2024', to: '08.10.2024'},
      {from: '13.08.2024', to: '21.10.2024'},
      {from: '03.09.2024', to: '12.11.2024'},
      {from: '17.09.2024', to: '26.11.2024'},
      {from: '01.10.2024', to: '10.12.2024'}
    ]
  },
  {
    name: 'Инструменты цифрового развития: проектный, процессный и продуктовый подходы',
    url: 'https://cdto.ranepa.ru/program-registry/digital-dev-management',
    cost: '65 000₽',
    streams: [
      {'from': '05.02.2024', 'to': '19.03.2024'},
      {'from': '20.02.2024', 'to': '03.04.2024'},
      {'from': '06.03.2024', 'to': '17.04.2024'},
      {'from': '19.03.2024', 'to': '04.05.2024'},
      {'from': '02.04.2024', 'to': '21.05.2024'},
      {'from': '17.04.2024', 'to': '05.06.2024'},
      {'from': '07.05.2024', 'to': '20.06.2024'},
      {'from': '21.05.2024', 'to': '02.07.2024'},
      {'from': '04.06.2024', 'to': '16.07.2024'},
      {'from': '18.06.2024', 'to': '29.07.2024'},
      {'from': '02.07.2024', 'to': '12.08.2024'},
      {'from': '17.07.2024', 'to': '27.08.2024'},
      {'from': '31.07.2024', 'to': '10.09.2024'},
      {'from': '14.08.2024', 'to': '24.09.2024'},
      {'from': '03.09.2024', 'to': '14.10.2024'},
      {'from': '17.09.2024', 'to': '28.10.2024'},
      {'from': '02.10.2024', 'to': '13.11.2024'},
      {'from': '08.10.2024', 'to': '19.11.2024'},
      {'from': '22.10.2024', 'to': '03.12.2024'}
    ]
  },
  {
    name: 'Реализация проектов цифровой трансформации',
    url: 'https://programs.cdto.center/page42173693.html ',
    cost: '350 000₽',
    streams: [
      { from: null, to: null, byRequest: true }
    ]
  },
  {
    name: 'Цифровое развитие организации в условиях глобальных вызовов',
    url: 'https://programs.cdto.center/page38572759.html#popup:infoblock',
    cost: '1 000 000₽',
    streams: [
      { from: null, to: null, byRequest: true }
    ]
  }
]

export { timetable }
